<template>
	<ModalComponent ref="modalRef" :isHeader="false" :isFooter="false" :is-background-transparent="true">
		<div class="text-white text-sm bg-grey-1 rounded-lg w-150 mb-6">
			<div class="text-center p-6">
				{{ $store.getters.paymentMethod == 'rped' || transaction.status == 'match'
					? 'Detail Transaksi'
					: 'Detail Order'
				}}
			</div>

			<hr class="border-2 border-transparent border-grey-4 m-0">

			<div class="p-6">
				<div class="bg-grey-2 rounded mb-3">
					<div class="p-3">
						<div class="flex justify-between items-center">
							<div>Status</div>
							<div>{{ transaction.statusShown }}</div>
						</div>

						<div v-if="transaction.status == 'pending'" class="text-xs text-grey mt-1">
							*Status order mungkin masih tertulis Waiting for Payment setelah Anda menyelesaikan pembayaran atau
							mebatalkan order. Status diperbarui otomatis setelah beberapa saat.
						</div>

						<div v-if="transaction.status == 'on_settlement' && transaction.direction == 'sell'"
							class="text-xs text-grey mt-1">
							The price has been locked and is currently awaiting the settlement process (FIFO).
						</div>
					</div>

					<hr
						v-if="!transaction.hideProfit && transaction.direction == 'sell' && (transaction.status == 'match' || transaction.status == 'on_settlement')"
						class="border border-transparent border-grey-1 my-0 mx--5" />
					<div
						v-if="!transaction.hideProfit && transaction.direction == 'sell' && (transaction.status == 'match' || transaction.status == 'on_settlement')"
						class="flex justify-between items-center p-3">
						<div>Profit</div>
						<div>
							{{ currency == 'usd'
								? transaction.profitUsdSign
								: transaction.profitIdrSign
							}}
							{{ currencySymbol }}
							{{ utils.currencyFormat(currency == 'usd'
								? transaction.profitUsd
								: transaction.profitIdr)
							}}
						</div>
					</div>
				</div>

				<div class="flex justify-between items-center mb-3">
					<div>Order Direction</div>
					<div :class="`${transaction.direction == 'buy' ? 'text-green' : 'text-red'}`">
						{{ transaction.direction == 'buy' ? 'Beli' : 'Jual' }}
					</div>
				</div>

				<div v-if="$store.getters.paymentMethod == 'rped'" class="flex justify-between items-center mb-3">
					<div>Order Type</div>
					<div class="capitalize">{{ transaction.orderType }}</div>
				</div>

				<div v-if="$store.getters.paymentMethod == 'rped'" class="flex justify-between items-center mb-3">
					<div>Contract</div>
					<div>{{ transaction.product }}</div>
				</div>

				<div class="flex justify-between items-center mb-3">
					<div>Order Date</div>
					<div>{{ transaction.date }}</div>
				</div>

				<div v-if="transaction.status == 'match' || transaction.status == 'on_settlement'"
					class="flex justify-between items-center mb-3">
					<div>Transaction Date</div>
					<div>{{ transaction.dateTransaction }}</div>
				</div>

				<div
					:class="`flex justify-between items-center ${transaction.status == 'match' || transaction.status == 'on_settlement' ? 'mb-3' : 'mb-6'}`">
					<template v-if="$store.getters.paymentMethod == 'rped' || transaction.orderId">
						<div>Order ID</div>
						<div>{{ transaction.orderId }}</div>
					</template>
					<template v-else>
						<div>Payment ID</div>
						<div>{{ transaction.pgOrderId }}</div>
					</template>
				</div>

				<div v-if="transaction.status == 'match' || transaction.status == 'on_settlement'"
					class="flex justify-between items-center mb-6">
					<div>Transaction ID</div>
					<div>{{ transaction.id }}</div>
				</div>

				<div class="flex justify-between items-center mb-3">
					<div>Quantity</div>
					<div class="number-font">{{ transaction.quantity }}</div>
				</div>

				<div
					:class="`flex justify-between items-center ${transaction.status == 'match' || transaction.status == 'on_settlement' ? 'mb-3' : 'mb-6'}`">
					<div>Total Gram</div>
					<div class="number-font">{{ transaction.totalGram }}</div>
				</div>

				<div v-if="transaction.status == 'match' || transaction.status == 'on_settlement'"
					class="flex justify-between items-center mb-6">
					<div>Price per Gram</div>
					<div class="number-font">
						{{ currencySymbol }}
						{{ utils.currencyFormat((currency == 'usd')
							? transaction.pricePerGramUsd
							: transaction.pricePerGramIdr) }}
					</div>
				</div>

				<div class="flex justify-between items-center mb-3">
					<div>
						{{ transaction.status == 'match' || transaction.status == 'on_settlement'
							? 'Metal Value of Trade'
							: 'Contract Value'
						}}
					</div>

					<div class="number-font">
						{{ currencySymbol }}
						{{ utils.currencyFormat((currency == 'usd')
							? transaction.metalValueOfTradeUsd
							: transaction.metalValueOfTradeIdr) }}
					</div>
				</div>

				<div class="flex justify-between items-center mb-3">
					<div>Fee</div>
					<div class="number-font">
						{{ minusSign }}
						{{ currencySymbol }}
						{{ utils.currencyFormat((currency == 'usd')
							? transaction.feeUsd
							: transaction.feeIdr) }}
					</div>
				</div>

				<div :class="`flex justify-between items-center
					${($store.getters.paymentMethod == 'gopay' && transaction.direction == 'sell')
						|| (transaction.status != 'match' && transaction.direction == 'buy')
						? 'mb-3' : 'mb-3'} `">
					<div>Tax</div>
					<div class="number-font">
						{{ minusSign }}
						{{ currencySymbol }}
						{{ utils.currencyFormat((currency == 'usd')
							? transaction.taxUsd
							: transaction.taxIdr) }}
					</div>
				</div>

				<div v-if="transaction.direction == 'sell'" :class="`flex justify-between items-center mb-3`">
					<div>Storage Fee</div>
					<div class="number-font">
						{{ currencySymbol }}
						{{ utils.currencyFormat(transaction.storageFee) }}
					</div>
				</div>

				<div v-if="transaction.direction == 'sell'" :class="`flex justify-between items-center mb-6`">
					<div>Total Sell Order</div>
					<div class="number-font">
						{{ currencySymbol }}
						{{ utils.currencyFormat((currency == 'usd')
							? transaction.settlementAmountUsd
							: transaction.settlementAmountIdr) }}
					</div>
				</div>

				<div v-if="transaction.status != 'match' && transaction.direction == 'buy'"
					:class="`flex justify-between items-center mb-6`">
					<div>FX Buffer</div>
					<div class="number-font">
						{{ currencySymbol }}
						{{ utils.currencyFormat((currency == 'usd'
							? transaction.fxBufferUsd
							: transaction.fxBufferIdr)) }}
					</div>
				</div>

				<div v-if="$store.getters.paymentMethod == 'gopay' && transaction.direction != 'sell'"
					:class="`flex justify-between items-center mt-3 ${transaction.direction == 'buy' && transaction.status == 'match' ? 'font-bold mb-1' : 'mb-6'}`">
					<div>
						{{ transaction.direction == 'buy' && transaction.status == 'match'
							? 'Settlement Amount'
							: 'Total Buy'
						}}
					</div>

					<div class="number-font">
						{{ currencySymbol }}
						{{ utils.currencyFormat((currency == 'usd')
							? transaction.settlementAmountUsd
							: transaction.settlementAmountIdr) }}
					</div>
				</div>

				<div
					v-if="$store.getters.paymentMethod == 'gopay' && transaction.direction == 'buy' && transaction.status == 'match'"
					class="text-right font-bold number-font mb-6">
					{{ currency == 'usd' ? 'Rp' : '$' }}
					{{ utils.currencyFormat((currency == 'usd')
						? transaction.settlementAmountIdr
						: transaction.settlementAmountUsd) }}
				</div>

				<hr
					v-if="$store.getters.paymentMethod == 'gopay' && transaction.direction == 'buy' && transaction.status == 'match'"
					class="border border-transparent border-grey-8 m-0 mb-6">

				<div v-if="$store.getters.paymentMethod == 'gopay'"
					:class="`flex justify-between items-center ${transaction.status != 'match' ? 'mb-6' : 'mb-3'}`">
					<div>Admin Fee</div>
					<div class="number-font">
						{{ minusSign }}
						{{ currencySymbol }}
						{{ utils.currencyFormat((currency == 'usd')
							? transaction.adminFeeUsd
							: transaction.adminFeeIdr) }}
					</div>
				</div>

				<div
					v-if="$store.getters.paymentMethod == 'gopay' && transaction.direction == 'buy' && transaction.status == 'match'"
					class="text-xs text-grey w-2/3 mb-6">
					An Admin Fee of 2% is deducted from the Estimated Total Buy. If the value of the Estimated Total Buy changes
					at the
					time of the Settlement Amount (order successfully executed), the Admin Fee will still be deducted based on the
					original Estimated Total Buy.
				</div>

				<div
					v-else-if="$store.getters.paymentMethod == 'gopay' && transaction.direction == 'sell' && transaction.status == 'match'"
					:class="`text-xs text-grey w-2/3 mb-6`">
					An admin fee of Rp2,500 is deducted from the Total Received.
					If the order experiences a partial fill, an admin fee of Rp2,500 will be charged for each partial fill /
					successfully matched transaction
				</div>

				<div
					v-if="$store.getters.paymentMethod == 'gopay' && transaction.direction == 'sell' && transaction.status == 'match'"
					class="font-bold mb-3">
					Settlement Amount
				</div>

				<div
					v-if="!($store.getters.paymentMethod == 'gopay' && transaction.direction == 'buy' && transaction.status == 'match')">
					<div
						:class="`flex justify-between font-bold ${$store.getters.paymentMethod == 'gopay' && transaction.status != 'match' ? 'mb-6' : 'mb-6'}`">
						<div v-if="$store.getters.paymentMethod == 'rped'">
							{{ transaction.direction == 'buy'
								|| (transaction.direction == 'sell'
									&& (transaction.status == 'on_settlement' || transaction.status == 'match'))
								? 'Settlement Amount'
								: 'Estimated Amount Receive' }}
						</div>
						<div v-else-if="transaction.status == 'match'" class="pl-3">
							<span v-if="transaction.transferTo == 'gopay'">to E-Wallet (GoPay)</span>
							<span v-else-if="transaction.transferTo == 'bank'">to Rekening Penarikan</span>
							<span v-else-if="transaction.transferTo == 'rped '">to RPED</span>
						</div>
						<div v-else-if="transaction.direction == 'buy'">Total Payment</div>
						<div v-else-if="transaction.direction == 'sell'">Estimated Amount Receive</div>

						<div class="number-font text-right">
							<div>
								{{ currencySymbol }}
								{{ utils.currencyFormat((currency == 'usd')
									? transaction.finalAmountUsd
									: transaction.finalAmountIdr) }}
							</div>
							<div v-if="transaction.direction == 'sell' && $store.getters.paymentMethod == 'rped'">
								{{ currency == 'usd' ? 'Rp' : '$' }}
								{{ utils.currencyFormat((currency == 'usd')
									? transaction.finalAmountIdr
									: transaction.finalAmountUsd) }}
							</div>
						</div>
					</div>

					<!-- <div v-if="$store.getters.paymentMethod == 'gopay' && transaction.status != 'match'"
						class="text-right font-bold number-font mb-6">
						{{ currency == 'usd' ? 'Rp' : '$' }}
						{{ utils.currencyFormat((currency == 'usd')
							? transaction.finalAmountIdr
							: transaction.finalAmountUsd) }}
					</div> -->
				</div>

				<hr v-if="transaction.status == 'match'" class="border border-transparent border-grey-8 m-0 mb-6">

				<div v-if="transaction.status == 'match'" class="flex justify-between items-center mb-6">
					<div>Trade Confirmation Invoice</div>

					<Loader v-if="invoiceLoading" size_prop="14px" borderSize_prop="1px"></Loader>
					<div v-else class="cursor-pointer text-theme"
						@click="invoice(transaction.orderMatchId, transaction.direction, transaction.status, transaction.id)">
						Download</div>
				</div>

				<div class="text-center">
					<button class="btn bg-theme h-10 min-w-28" @click="closeDetailTransaction()">OK</button>
				</div>
			</div>
		</div>
	</ModalComponent>
</template>

<script>
import axios from '@/api/axios.js'

import ModalComponent from '../../ModalComponent.vue'
import Loader from '../../Loader.vue'

import utils from '@/utils/index.js'

export default {
	name: 'DetailTransaction',
	props: {
		dataTransaction: {
			type: Object,
			required: true
		}
	},

	components: {
		ModalComponent,
		Loader,
	},

	data() {
		return {
			utils: utils,
			invoiceLoading: false,
		}
	},

	computed: {
		currency() {
			return this.$store.state.currency
		},

		transaction() {
			return this.dataTransaction
		},

		minusSign() {
			return this.dataTransaction.direction == 'sell' ? '-' : ''
		},
	},

	methods: {
		openDetailTransaction() {
			this.$refs.modalRef.openModal()
		},

		closeDetailTransaction() {
			this.$refs.modalRef.closeModal()
		},

		invoice(orderMatchId, direction, transactionStatus, transactionRef) {
			// If Transaction Status == On Process, cannot download pdf
			if (transactionStatus == 'On Process') {
				return false
			}

			this.invoiceLoading = true
			axios({
				method: 'POST',
				url: process.env.VUE_APP_BACKEND_URL + '/igx/reports/pdf/transaction_invoice',
				// responseType: 'arraybuffer',
				data: {
					order_match_id: orderMatchId,
					direction: direction,
				},
			}).then(response => {
				let datanya = response.data.data.body.data

				// let byte = this.base64ToArrayBuffer(datanya)
				const arrTes = new Uint8Array(datanya)
				let blob = new Blob([arrTes], { type: "application/pdf" })
				console.log('berhasil invoice', response, datanya, arrTes, blob)
				let link = document.createElement('a')
				link.href = window.URL.createObjectURL(blob)
				let fileName = 'trade_confirmation_invoice-' + orderMatchId
				link.download = fileName
				link.click()

				this.invoiceLoading = false

				console.log("berhasil invoice", response)
			}).catch(error => {

				if (error.response.data.data.status_code == 'FileNotExist') {
					Alert.open({
						type: 'info',
						title: 'Dokumen sedang Dipersiapkan',
						description: 'Dokumen PDF Anda sedang diproses, Silakan coba beberapa saat lagi (Estimasi 1-2 menit)',
					})
				} else {
					Alert.open({
						type: 'error',
						title: 'Gagal Mengunduh Dokumen',
						description: 'Terjadi kesalahan saat mengunduh dokumen PDF, silakan coba beberapa saat lagi',
					})
				}

				this.invoiceLoading = false
			})
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>